import { extend } from 'vee-validate';
import { validator } from './runtime';

extend('slideshow', {
    ...validator
    //message: 'Some slides need your attention'
});
